export default "__VITE_ASSET__BxzVZf8o__"